import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sideBarInfo: {
    min: false,
    shipments: false,
    current: false,
    address: false,
    reports: false,
    definition: false,
  },
};

export const sideBarSlice = createSlice({
  name: 'sideBar',
  initialState,
  reducers: {
    updateSideBarInfoField: (state, action) => {
      const { value, field } = action.payload;
      state.sideBarInfo[field] = value;
    },
  },
});

export const sideBarInfoSelector = (state) => state.sideBar.sideBarInfo;
export const { updateSideBarInfoField } = sideBarSlice.actions;

export const sideBarReducer = sideBarSlice.reducer;
export const sideBarReducerName = sideBarSlice.name;

export default sideBarSlice.reducer;
